<template>
	<div>
		<v-checkbox
			label="Nerodyti legendos peržiūros režime"
			dense
			hide-details
			class="ma-0 pa-0"
			v-model="noLegendInPreview"
		></v-checkbox>
	</div>
</template>

<script>
	export default {
		data: function(){
			var noLegendInPreview = Boolean(this.data.myMap.noLegendInPreview);
			var data = {
				noLegendInPreview: noLegendInPreview
			};
			return data;
		},
		props: {
			data: Object
		},
		watch: {
			noLegendInPreview: {
				immediate: true,
				handler: function(noLegendInPreview){
					this.data.myMap.noLegendInPreview = noLegendInPreview;
				}
			}
		}
	}
</script>